import {
  GET_LIST_TINCHAP,
  GET_LIST_TINCHAP_SUCCESS,
  GET_LIST_TINCHAP_FAILURE,
} from "./actionTypes";

export const getListTinChap = (dataSearch) => ({
  type: GET_LIST_TINCHAP,
  dataSearch,
});

export const getListTinChapSuccess = (data) => ({
  type: GET_LIST_TINCHAP_SUCCESS,
  payload: data,
});

export const getListTinChapFailure = () => ({
  type: GET_LIST_TINCHAP_FAILURE,
});
